import CardValidator from 'card-validator';

const AVAILABLE_CARDS = ['visa', 'mastercard', 'american-express', 'discover'];

export function isValidCardType(type) {
  return AVAILABLE_CARDS.indexOf(type) !== -1;
}

export function isValidCardName(cardName) {
  return cardName.trim().length >= 2;
}

export function isValidCardNumber(cardNumber) {
  let isValidNumber = false;
  const numberValidation = CardValidator.number(cardNumber);

  if (numberValidation.card) {
    isValidNumber =
      numberValidation.isValid && isValidCardType(numberValidation.card.type);
  }

  return isValidNumber;
}

export function isValidCardExpDate(cardExpMonth, cardExpYear) {
  const expirationDateValidation = CardValidator.expirationDate({
    month: cardExpMonth,
    year: cardExpYear
  });

  return expirationDateValidation.isValid;
}

export function isValidCardCvv(cardNumber, cardCvv) {
  const numberValidation = CardValidator.number(cardNumber);
  const cvvValidation = numberValidation.card
    ? CardValidator.cvv(cardCvv, numberValidation.card.code.size)
    : CardValidator.cvv(cardCvv);

  return cvvValidation.isValid;
}

export default {
  isValidCardName,
  isValidCardNumber,
  isValidCardExpDate,
  isValidCardCvv
};
